import { render, staticRenderFns } from "./Title_Customer.vue?vue&type=template&id=4e88e6a4&scoped=true&"
import script from "./Title_Customer.vue?vue&type=script&lang=js&"
export * from "./Title_Customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e88e6a4",
  null
  
)

export default component.exports